import React from "react";
import ViewCoursesFor from "./courses_for";

export default function CourseEmbed(props) {
    return <>
        VEREINFACHT Kurse
        <ViewCoursesFor linkPrefix={"/buche"} {...props} id={"all"} category={50}/>
    </>
}